import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Red pending-offers badge for the Admin nav link. Only active while an admin is logged in.
export const AdminOffersBadge = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let alive = true;
    const load = () => {
      if (!localStorage.getItem("admin_token")) {
        if (alive) setCount(0);
        return;
      }
      api.get("/admin/exclusive-offers/pending-count")
        .then((r) => { if (alive) setCount(r.data.count || 0); })
        .catch(() => {});
    };
    load();
    const timer = setInterval(load, 15000);
    const onFocus = () => load();
    window.addEventListener("focus", onFocus);
    return () => {
      alive = false;
      clearInterval(timer);
      window.removeEventListener("focus", onFocus);
    };
  }, []);

  if (!count) return null;
  return (
    <span
      data-testid="nav-offers-badge"
      className="absolute -right-1.5 -top-1.5 flex h-5 min-w-5 items-center justify-center rounded-full bg-red-500 px-1 font-mono text-[10px] font-bold text-white shadow-[0_0_12px_rgba(239,68,68,0.6)]"
    >
      {count > 99 ? "99+" : count}
    </span>
  );
};
